import React from 'react'
import "./PlainText.css"
import { useNavigate } from 'react-router-dom'

function PlainText() {
    const navigate = useNavigate()
  return (
    <div className='PlainText-container standard-padding-space'>
        <div className='container'>
            <div className='text-center text-content mx-auto'>
                <h3 className=' body-heading'>Smart, Scalable & Cost-Effective Accounting Solutions</h3>
                <p className='body-paragraph my-4'>Are you spending too much time managing your books instead of growing your business? Lotus Accounting provides outsourced accounting services that help businesses streamline their financial operations, reduce overhead costs, and gain real-time financial insights—all without the need for an in-house accounting team.</p>

                <h3 className='sub-heading'>Accurate Financials | Compliance Assured | Scalable Growth</h3>
                <p className='body-paragraph mt-4'>Let us take care of your numbers while you focus on your business success!</p>

            </div>

            <div className='btn-container d-flex flex-lg-row flex-column align-items-center justify-content-center gap-4 mt-5 '>
                <button className='blue-btn ' onClick={()=>{window.open("https://calendly.com/chandrancpa","blank")}}>Schedule a Consultation </button>
                <button className='hero-btn' onClick={()=>{window.open("tel:+14169042013")}}>+14169042013</button>
            </div>

            <div className='img-container  w-100 mt-5'>
                <img loading="lazy" src='/images/creative/os-plaine-text-img-1.webp' alt='office meeting' className='img-fluid w-100' />
            </div>
        </div>
    </div>
  )
}

export default PlainText